import { Component, ChangeDetectionStrategy, Type } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { BaseFormlyFieldProps } from '../form-field/public_api';

interface TextAreaProps extends BaseFormlyFieldProps { }

export interface FormlyTextAreaFieldConfig extends FormlyFieldConfig<TextAreaProps> {
    type: 'kendo-textarea' | Type<FormlyFieldTextArea>;
}

@Component({
    selector: 'formly-field-kendo-textarea',
    template: ` <textarea kendoTextArea [rows]="props.rows" [formControl]="formControl" [formlyAttributes]="field"></textarea> `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldTextArea extends FieldType<FieldTypeConfig<TextAreaProps>> { }
